import React, { useEffect, useRef } from "react"
import { Button, CircularProgress, Fade, Paper, Popper } from "@material-ui/core"
import AddIcon from "@material-ui/icons/Add"
import UploadPopper from "./UploadPopper"
import { useDispatch, useSelector } from "react-redux"
import { getUploadFileStatusRequest, setUploadOpen, uploadFileRequest } from "../../../../actions/uploadActions"
import useStyles from "./uploadStyles"
import { useInterval } from "../../../../utils"
import useSnackbarNotification from "../../../../utils/customHooks/useSnackbarNotification"
import { useTranslation } from "react-i18next"

const Upload = ({ open, setOpen }) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [t] = useTranslation("global")
	const { addSnackbar } = useSnackbarNotification()

	const isUploadInprogress = useSelector((state) => state.upload.isUploadInprogress)
	const isUploading = useSelector((state) => state.upload.isUploading)
	const notifications = useSelector((state) => state.upload.notifications)

	const poperRef = useRef(null)
	const id = open ? "transitions-popper" : undefined

	const toggleUpload = () => {
		dispatch(setUploadOpen(!open))
		setOpen((prev) => !prev)
	}

	const onSubmit = (files) => {
		console.log("files", files)
		dispatch(uploadFileRequest(files))
	}

	// useEffect(() => {
	// 	dispatch(getUploadFileStatusRequest())
	// }, [])

	useEffect(() => {
		if (notifications?.length) {
			addSnackbar(notifications)
		}
	}, [notifications])

	useInterval(
		() => {
			if (isUploadInprogress) {
				dispatch(getUploadFileStatusRequest())
			}
		},
		1000 * 3,
		false,
		[]
	)

	return (
		<div className={classes.root}>
			<Button
				variant="contained"
				color="secondary"
				className={`${classes.uploadButton} ${classes.button}`}
				startIcon={isUploading ? <CircularProgress size={20} className={classes.progress} /> : <AddIcon />}
				ref={poperRef}
				onClick={toggleUpload}
				disabled={isUploading}
			>
				{isUploading ? t("dropZone.btnUploading") : t("dropZone.btnUpload")}
			</Button>
			<Popper
				id={id}
				open={open}
				anchorEl={poperRef.current}
				transition
				placement="bottom-end"
				disablePortal={true}
				modifiers={{
					flip: {
						enabled: false,
					},
					preventOverflow: {
						enabled: true,
						boundariesElement: "window",
					},
					//gpuAcceleration: false,
				}}
				style={{ zIndex: 2, top: 15 }}
			>
				{({ TransitionProps }) => (
					<Fade {...TransitionProps} timeout={350}>
						<Paper className={classes.uploadForm}>
							<UploadPopper onClose={toggleUpload} onSubmit={onSubmit} />
						</Paper>
					</Fade>
				)}
			</Popper>
		</div>
	)
}

export default Upload
